<template>
  <div :style="`paddingTop:${barHeight}px`">
    <van-nav-bar :title="this.$i18n.locale == 'zh' ? '用戶隱私協議' : 'Privacy Policy'" left-arrow @click-left="closeWeb"></van-nav-bar>
    <div class="page-container" v-if="this.$i18n.locale == 'zh'">
      <p>GoParty非常重视保护用户的隐私权，在使用GoParty之前，请您务必仔细阅读并透彻理解本隐私声明。</p>
      <p>使用GoParty即表示您认可并接受本声明现有内容及其可能随时更新的内容。</p>
      <p>鉴于网路的特性，本应用将无可避免地与您产生直接或间接的互动关係，故特此说明本应用对用户个人资讯的收集、使用和保护政策，请您务必仔细阅读：</p>
      <p>1适用范围</p>
      <p>本声明适用于由GoParty应用提供的服务，解释了用户资讯收集和使用的有关情况。</p>
      <p>本声明不适用于由其他社会组织或者个人提供的服务。</p>
      <p>2 用户非个人化资讯</p>
      <p>
        我们将通过您的IP地址来收集非个人化的资讯，例如您的浏览器性质、操作系统种类、给您提供接入服务的ISP的功能变数名称等，以优化在您手机萤幕上显示的页面。
        通过收集上述资讯，我们进行客流量统计，从而改进应用的管理和服务。
      </p>

      <p>3 个人资讯</p>
      <p>3.1 当您在GoParty进行用户注册登记时候，在您的同意及确认下，本应用将通过注册表格、订单等形式要求您提供一些个人资讯。这些个人资讯包括：</p>
      <p>3.1.1 个人识别资讯：如姓名、性别、身份证号码、电话、电子邮件地址等情况。</p>
      <p>3.1.2 个人背景：年龄、职业、教育程度等。</p>
      <p>
        3.2
        请瞭解，在未经您同意及确认之前，本应用不会将您为参加本应用之特定活动所提供的资讯利用于其他商业目的（本应用用于改善、提升服务品质除外）。唯按下列第4.4条规定应政府及法律要求披露时不在此限。
      </p>
      <p>3.3如果因注册资讯不真实而引起的问题，由您自行承担相应的后果。</p>
      <p>4 资讯使用</p>
      <p>4.1.通过使用收集的资讯，GoParty会得以向您提供个性化的服务。上述资讯还可以帮助改进本应用的服务，并用于开发新的服务。</p>
      <p>4.2.GoParty会以高度的勤勉义务对待这些资讯，除非事先获得您的授权或本声明另有规定外，不会将这些资讯对外公开或向第三方提供（GoParty关联公司除外）。</p>
      <p>
        4.3GoParty可能会与合作伙伴共同向您提供您所要求的服务或者共同向您展示您可能感兴趣的内容。在资讯为该项服务所必须的情况下，您同意GoParty可与其分享必要的信息、资讯。并且，GoParty会要求其确保信息、资讯安全并且禁止用于任何其他用途。除此之外，GoParty不会向任何无关第三方提供或分享信息、资讯。
      </p>
      <p>4.4在如下情况下，GoParty可能会披露您的信息、资讯：</p>
      <p>（1）事先获得您的授权；</p>
      <p>（2）您使用共用功能；</p>
      <p>（3）根据法律、法规、法律程式的要求或政府主管部门的强制性要求；</p>
      <p>（4）以学术研究或公共利益为目的；</p>
      <p>（5）为维护GoParty的合法权益，例如查找、预防、处理欺诈或安全方面的问题；</p>
      <p>（6）符合相关服务条款或协议的规定。</p>
      <p>5 资讯安全</p>
      <p>5.1 本应用将对您所提供的资讯进行严格的管理及保护，本应用将使用相应的技术，防止您的个人资讯丢失、被盗用或遭篡改。</p>
      <p>
        5.2
        本应用在必要时委託专业技术人员代为对该类资讯进行电脑处理，以符合专业分工时代的需求。如本应用将电脑处理之通知送达予您，而您未在通知规定的时间内主动明示反对，本应用将推定您已同意。唯在其后您仍然有权如下述第4.1.4条之规定，请求停止电脑处理。
      </p>
      <p>
        5.3请您不要将您的帐号、密码转让或出借予他人使用。如您发现您的帐号遭他人非法使用，应立即通知GoParty。互联网上不排除因骇客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，此类情况与GoParty无关。
      </p>
      <p>5.4请您使用採取合理措施进一步保障您的资讯安全。</p>
      <p>6 未成年人资讯保护</p>
      <p>GoParty非常重视对未成年人资讯的保护。若您是18周岁以下的未成年人，在使用GoParty服务前，应事先取得您的家长或法定监护人的同意。</p>
      <p>7 特别事项</p>
      <p>
        GoParty为您提供个人空间、录制及上传音频、发表评论等服务。在这些区域内，您公佈的任何资讯都会成为公开的资讯。因此，GoParty提醒并请您慎重考虑是否有必要在这些区域公开您的个人资讯。
      </p>
      <p>8 修订</p>
      <p>GoParty随时会对本隐私权保护声明进行修订。GoParty会在网页/应用/产品中显著的位置予以发佈。</p>
      <p>本应用之保护隐私声明的修改及更新、解释权均属于GoParty。</p>
    </div>
    <!-- <div class="page-container" v-if="this.$i18n.locale == 'en'" v-html="$t('lang.goParty.privacy')"></div> -->
    <div class="page-container" v-else v-html="this.$t('lang.goParty.privacy')"></div>
  </div>
</template>

<script>
import { setTitleIcon } from '@/utils/public.js'

export default {
  data() {
    return {}
  },
  created() {},
  mounted() {
    setTitleIcon()
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.page-container {
  // margin-top: 46px;
  height: calc(100vh);
  padding: 0 15px;
  font-size: 14px;
  line-height: 22px;
  overflow: auto;
  text-align: left;

  .h2 {
    margin: 10px 0;
    font-size: 16px;
  }
}

::v-deep .van-nav-bar__content {
  display: block;
  line-height: 46px;
  background-color: #fff;
}
::v-deep .van-nav-bar .van-icon {
  color: #000 !important;
  font-size: 18px;
}
::v-deep .van-nav-bar__title {
  color: #000;
}
</style>
